import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { AllowedIpFilterOptions } from '../models/allowed-ip-filter-option';
import { AllowedIpRegisterListItem } from '../models/allowed-ip-register-results.model';

const area = 'Allowed IP Register';

export const allowedIpRegisterAdapterActions = createRegisterActions<AllowedIpRegisterListItem>(area);

export const refreshList = createAction(`[${area}] Refresh List`);

export const createAllowedIp = createAction(`[${area}] Create Allowed IP`);

export const allowedIpRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: AllowedIpFilterOptions[] }>()
);

export const deleteAllowedIp = createAction(
   '[Allowed IP Detail] Delete Allowed IP',
   props<{ allowedIpAddressId: number; ipAddress: string }>()
);

export const deleteAllowedIpSuccess = createAction(
   '[Allowed IP Detail] Delete Allowed IP Success',
   props<{ ipAddress: string }>()
);

export const deleteAllowedIpFailure = createAction(
   '[Allowed IP Detail] Delete Allowed IP Failure',
   props<SingleGraphError>()
);

export const editAllowedIpSubmit = createAction(
   '[Allowed IP] Edit Allowed IP Submit',
   props<{
      allowedIpAddressId: number;
      qManageTicketId: string | null;
      accountId: number;
      fields: string[];
   }>()
);
export const editAllowedIp = createAction(
   `[${area}] Edit Allowed Ip`,
   props<{ allowedIp: AllowedIpRegisterListItem }>()
);

export const editAllowedIpSuccess = createAction(`${area} Edit Allowed Success`);

export const editAllowedIpFailure = createAction(`${area} Edit Allowed IP Failure`, props<{ error: any }>());
